import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 11v-4a4 4 0 1 1 8 0v4" })
	]
});
export { SvgLock as ReactComponent };
